import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { DollarIcon } from './Icons';
import './FloatingDonateButton.css';

const FloatingDonateButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToDonation = () => {
    const element = document.getElementById('donation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      className={`floating-donate-btn ${isVisible ? 'visible' : ''}`}
      onClick={scrollToDonation}
      aria-label={language === 'ar' ? 'تبرع الآن' : 'Donate Now'}
    >
      <div className="floating-donate-icon">
        <DollarIcon />
      </div>
      <span className="floating-donate-text">
        {language === 'ar' ? 'تبرع' : 'Donate'}
      </span>
    </button>
  );
};

export default FloatingDonateButton;
